import {SnackBarActions} from '@store/aviary/aviary.adapter';
import {
  AUTH_PATRON_MISSING_MESSAGE,
  CUSTOM_ERROR_HANDLERS_CREATOR,
  CustomErrorHandlersCreator,
  REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE
} from '@aviary/interceptors/http-error-interceptor.types';
import {HttpContext} from '@angular/common/http';

export function contextWithErrorHandlerForLoadAuthPatron(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // the authenticated patron was not found
          errorCodes: 'PATRON_INVALID_ID',
          actions: SnackBarActions.showError(AUTH_PATRON_MISSING_MESSAGE)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForLoadAccountStatus(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // the authenticated patron was not found
          errorCodes: 'ENTITY_ID_NOT_FOUND',
          actions: SnackBarActions.showError(AUTH_PATRON_MISSING_MESSAGE)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForLoadPatronReferenceOptions(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // the authenticated organization was not found
          errorCodes: 'GENERAL_INVALID_VALUE',
          actions: SnackBarActions.showError(`Library information not found. ${REFRESH_AND_TRY_AGAIN_ERROR_MESSAGE}`)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForChangePatronEmail(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // the requested email already exists in the database
          errorCodes: 'GENERAL_DUPLICATE_EMAIL',
          actions: SnackBarActions.showError('This email is already in use.')
        },
        {
          // the requested email is blank or invalid
          errorCodes: 'GENERAL_INVALID_VALUE',
          actions: SnackBarActions.showError('Invalid email.')
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForUpdatePatron(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // the requested branch id was not found
          errorCodes: 'BRANCH_INVALID_ID',
          actions: SnackBarActions.showError('Invalid branch selection.')
        },
        {
          // the requested pronouns object was not found
          errorCodes: 'ENTITY_ID_NOT_FOUND',
          actions: SnackBarActions.showError('Invalid pronouns selection.')
        },
        {
          // authenticated patron not found
          errorCodes: 'PATRON_INVALID_ID',
          actions: SnackBarActions.showError(AUTH_PATRON_MISSING_MESSAGE)
        }
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}

export function contextWithErrorHandlerForUpdateNotificationPreferences(): HttpContext {
  const handler: CustomErrorHandlersCreator = () => ({
    400: {
      discardOriginalErrorResponse: false,
      actionMappers: [
        {
          // the authenticated patron was not found
          errorCodes: 'ENTITY_ID_NOT_FOUND',
          actions: SnackBarActions.showError(AUTH_PATRON_MISSING_MESSAGE)
        },
        {
          // wrapper for requested preferences was missing
          errorCodes: 'GENERAL_MISSING_PARAM',
          actions: SnackBarActions.showError('Missing or invalid notification preferences.')
        },
        // errorCodes: 'GENERAL_INVALID_VALUE' - the api is supplying good specific errors for invalid parameters, intentionally not overriding it here
      ]
    }
  });
  return new HttpContext().set(CUSTOM_ERROR_HANDLERS_CREATOR, handler);
}
